export default __webpack_public_path__ + "static/media/sidebar-bullet-disable-dark.48cf981a.svg";